
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/widgets/mediashare",
      function () {
        return require("private-next-pages/widgets/mediashare.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/widgets/mediashare"])
      });
    }
  